<div class="row mb-2 align-items-center">
  <div class="col">
    <div class="tag-list mb-n2">
      @for (location of locations; track location) {
        <span class="tag me-2 mb-2">{{ location.City }} <i (click)="removeLocation(location)" class="fa-sharp fa-regular fa-xmark ms-2 clickable"></i></span>
      }
    </div>
  </div>
</div>
<input [placeholder]="texts.searchPlaceholder[language]" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" class="form-control form-control-sm" #search>